export default __webpack_public_path__ + "static/media/Left003.7d15a9fc.png";